// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"Error_errorPage__F7YUx","danger":"Error_danger__oZ5XY","normal":"Error_normal__2ay4A"};